module.exports = __webpack_public_path__ + "img/64_6.96d5ee17.png";